import React from 'react'
import { Link } from 'react-router-dom'
import iconTop from '../../../../assets/html/dist/img/shop-ui_icon_movie-management-red.png'

const VideoType: React.FC<{}> = () => (
  <div className="tab-pane fade" id="StoreInformation-PriceRangeCategory" role="tabpanel" aria-labelledby="StoreInformation-PriceRangeCategory-tab">
    <h3><img src={iconTop} alt="店舗情報" /> 動画カテゴリ</h3>
    <div className="row form-group">
      <label className="col-3 col-form-label">タイトル</label>
      <div className="col-8">
        <input className="form-control" type="text" placeholder="入力してください" />
      </div>
    </div>
    <div className="row form-group">
      <label className="col-3 col-form-label">説明文</label>
      <div className="col-8">
        <textarea className="form-control" rows={5} placeholder="入力してください">{' '}</textarea>
      </div>
    </div>
    <div className="row form-group mt-3">
      <label className="col-3 col-form-label">アップロード</label>
      <div className="col-9">
        <div className="d-flex">
          <input type="file" id="upload" hidden />
          <label className="custom-input-file" htmlFor="upload">ファイルを選択</label>
          <div style={{ lineHeight: 1.5, fontSize: 15, color: '#000', marginLeft: '1rem', width: 240 }}>MP4,MOVを10MBまで。<br /> 複数アップロードできます。</div>
        </div>
      </div>
    </div>
    <div className="row form-group">
      <label className="col-3 col-form-label">カテゴリ</label>
      <div className="col-8">
        <div className="d-flex">
          <select className="form-control">
            <option selected>選択してください</option>
            <option>...</option>
          </select>
          <i className="fas fa-plus-circle icon-add">{' '}</i>
        </div>
      </div>
    </div>
    <div className="row form-group">
      <label className="col-3 col-form-label">表示順</label>
      <div className="col-8">
        <input className="form-control" type="text" style={{ width: 100 }} />
      </div>
    </div>
    <div className="row form-group mt-3">
      <label className="col-3 col-form-label">公開設定</label>
      <div className="col-8">
        <div className="btn-group btn-group-toggle" data-toggle="buttons">
          <label className="btn ">
            <input type="radio" name="options" id="option_a1" checked /> 公開
          </label>
          <label className="btn active">
            <input type="radio" name="options" id="option_a2" /> 非公開
          </label>
        </div>
      </div>
    </div>
    <div className="mt-4 text-center"><button type="button" className="btn bg-danger w-75">保存</button></div>
  </div>
)
export default VideoType
